import { render, staticRenderFns } from "./WikiPagePartialList.vue?vue&type=template&id=35598fa8&scoped=true"
import script from "./WikiPagePartialList.vue?vue&type=script&lang=ts"
export * from "./WikiPagePartialList.vue?vue&type=script&lang=ts"
import style0 from "./WikiPagePartialList.vue?vue&type=style&index=0&id=35598fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35598fa8",
  null
  
)

export default component.exports